import $ from "jquery";

$('.tabs_d9e4').each(function(){
  var $tabs = $(this);
  var $ul = $tabs.find('ul');
  var $li = $tabs.find('li');
  var $first_li = $li.first();
  var data_tab_content= "url";

  $first_li.addClass('active');

  $li.hover( function(){

    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).find('p').slideUp();
    } else {
      $li.removeClass('active');
      $li.find('p').slideUp();
      $(this).find('p').slideDown();
      $(this).addClass('active');
    }
    data_tab_content = $(this).data('tab-content');

      if ($('.corresponding_tab_image img').attr('src') != data_tab_content){
        $('.corresponding_tab_image').fadeTo("fast", 0, function() {
          $('.corresponding_tab_image img').attr("src", data_tab_content);
          $('.corresponding_tab_image').fadeTo("fast", 1);
        });
      }
  });

});
